module.exports = __webpack_public_path__ + "static/media/early-version-2.c994ec53.png";